<app-stages [stages]="stages" [currentStage]="customTitles?.sectionTitle || 'Wykonawca'"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <div class="custom-radio custom-inline">
            <input (change)="form.dataSameAsApplicantChange(false)" name="dataSameAsApplicant"
                   formControlName="dataSameAsApplicant" type="radio"
                   id="dataSameAsApplicantFalse" [value]="false">
            <label for="dataSameAsApplicantFalse">
              {{ customTitles?.dataSameAsApplicantLabels?.rejectLabel || 'Chcę wprowadzić dane inwestora' }}
            </label>
          </div>
          <div class="custom-radio custom-inline">
            <input (change)="form.dataSameAsApplicantChange(true)" name="dataSameAsApplicant"
                   formControlName="dataSameAsApplicant" type="radio"
                   id="dataSameAsApplicantTrue" [value]="true">
            <label for="dataSameAsApplicantTrue">
              {{ customTitles?.dataSameAsApplicantLabels?.acceptLabel || 'Dane inwestora są takie same jak dane wnioskodawcy' }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </form>
  @if (!form.dataSameAsApplicant.value) {
    <app-contractors-preview
      [expanded]="false"
      [noDataInfo]="customTitles?.noDataInfo || null"
      (onRemove)="form.removeContractorItem($event)"
      (onEdit)="onEditContractor($event.i, $event.v)"
      [canEdit]="!showItemForm"
      [showActions]="true"
      [contractors]="form.contractorsValues">
    </app-contractors-preview>
    @if (!showItemForm) {
      <br>
      <div class='d-flex justify-content-end'>
        <button type='button' class='btn btn-primary' (click)='onAdd()'>
          {{ form.contractorsValues.length ? (customTitles?.addBtn2Title || "Dodaj kolejnego wykonawcę") : (customTitles?.addBtnTitle || "Dodaj wykonawcę") }}
        </button>
      </div>
    }
    @if (showItemForm) {
      <div class='gov-card'>
        <div class='gov-card__header'>
          {{ customTitles?.cardTitle || "Dodanie wykonawcy" }}
        </div>
        <div class='gov-card__body'>
          <app-tab-view #tabViewComponent [centered]='true'>
            @for (entityType of entityTypes(); track $index) {
              @if (entityType.code === 'OSOBA_PRAWNA') {
                <app-tab-panel #companyTab [name]='entityType.name' [selected]='true'>
                  <app-contractor-company-form
                    *ngIf='companyTab.selected'
                    [edit]='currentIndex() !== undefined'
                    [form]='itemForm'
                    (onCancel)='showItemForm = false'
                    (onSubmit)='onUpdateContractors($event)'>
                  </app-contractor-company-form>
                </app-tab-panel>
              }
              @if (entityType.code === "OSOBA_FIZYCZNA") {
                <app-tab-panel #naturalPersonTab [name]='entityType.name'>
                  <app-contractor-natural-person-form
                    *ngIf='naturalPersonTab.selected'
                    [edit]='currentIndex() !== undefined'
                    [form]='itemForm'
                    (onCancel)='showItemForm = false'
                    (onSubmit)='onUpdateContractors($event)'>
                  </app-contractor-natural-person-form>
                </app-tab-panel>
              }
            }
          </app-tab-view>
        </div>
      </div>
      <br>
    }
  }
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary' (click)='onCancel()'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      [disabled]="!form.dataSameAsApplicant.value && showItemForm"
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
